const getTextFromHTMLElement = (
  content: string,
  tags = ['h1', 'h2', 'h3', 'h4', 'p']
) => {
  let text = ''

  tags.some((tag) => {
    const array = new RegExp(`<${tag}>(.*?)</${tag}>`).exec(content)
    if (array && array[1]) {
      text = array[1].replace(/<\/?[^>]+(>|$)/g, '')
    }
    return text && text !== ''
  })

  return text
}

export { getTextFromHTMLElement }
